/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:5079e0e5-5df7-4167-b353-0d93c1e331f5",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_OeFpI6mAa",
    "aws_user_pools_web_client_id": "2a48i1b8ljiucror24ifvc1r5m",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "webreactcropwisegrowe8c9ac5615c44dd49ca92d3578fef422-dev",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
